import styled from 'styled-components'
import { LayoutComponent } from '@/layout'
import CloseCheck from '../../assets/img/close-check.png'
import { useParams, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { trackEvent } from '@/services/analytics.service'

const PageStyle = styled.section`
  .check-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 300px;
    margin: 0 auto 16px;
    text-align: center;
    img {
      max-width: 100px;
    }
  }
`

const DEFAULT_ERROR_MESSAGE = 'Ha ocurrido un error inesperado'

export function ErrorPage (): JSX.Element {
  const { id } = useParams<{ id: string }>()
  const [searhParams] = useSearchParams()
  const message = searhParams.get('message') ?? DEFAULT_ERROR_MESSAGE

  useEffect(() => {
    trackEvent('error_view', {
      error_message: message,
      prescription_id: id
    })
  }, [message, id])

  return (
    <LayoutComponent>
      <PageStyle>
        <div className='check-container'>
          <img src={CloseCheck} alt='' />
        </div>
        <div className='response-container'>
          <p>
            {message}
          </p>
        </div>
      </PageStyle>
    </LayoutComponent>
  )
}
